import { render, staticRenderFns } from "./rule14.vue?vue&type=template&id=5e9c4418&scoped=true"
import script from "./rule14.vue?vue&type=script&lang=js"
export * from "./rule14.vue?vue&type=script&lang=js"
import style0 from "./rule14.vue?vue&type=style&index=0&id=5e9c4418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c4418",
  null
  
)

export default component.exports